import apiempresaweb from '@/services/api-recebimentoweb';
import db from '@/plugins/dexie';

// CONVERTE O REGISTRO DA TABELA LOCAL PARA O MESMO FORMATO RETORNADO PELA API
function empresaLocalParaApi(item) {
  return {
    id: item.empidnuvem,
    empidempresa: item.empidempresa,
    empnome: item.empnome,
    empcnpj: item.empcnpj,
    empsafra: item.empsafra,
    empdominiochecklist: item.empdominiochecklist,
    empdataalteracao: item.empdataalteracao,
  };
}

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      try {
        const { data } = await apiempresaweb.get('empresa', { params: { ...where, ...params } });
        return data;
      } catch (err) {
        // SEM CONEXÃO (SEM err.response): USA OS DADOS SALVOS NO DEXIE
        if (err.response) throw err;
        const locais = await db.empresa.toArray().catch(() => []);
        return locais.map(empresaLocalParaApi);
      }
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
